import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

interface PageHeaderProps {
  onBack: () => void;
}

export function PageHeader({ onBack }: PageHeaderProps) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
      <Button onClick={onBack} sx={{ minWidth: 0, p: 0, mr: 1, color: '#23272E', fontSize: 22 }}>
        <ArrowBackIosNewIcon />
      </Button>
      <Typography sx={{ color: '#23272E', fontWeight: 800, fontSize: 26, letterSpacing: -1 }}>
        Visualizar Morador
      </Typography>
    </Box>
  );
}